module.exports = __webpack_public_path__ + "static/nslide5-739ab6dc138ce908f84681995dd0c7c4.png";